module.exports = __webpack_public_path__ + "img/prt.ab5aba42.png";